<div class="header-bar">
  <h1>Hide Job Reasons - Admin</h1>
</div>
<div class="content-container">
  <div class="">
    <div class="flex filterPanel flex-wrap grid-gap-10">
      <div class="">
        <span class="md-inputfield filterItem">
          <input
            name="reason"
            [(ngModel)]="reasonText"
            pInputText
            maxlength="100"
            placeholder="Hide Reason"
            style="width: 100%"
          />
        </span>
      </div>

      <div class="pt-2">
        <p-checkbox
          id="rt"
          name="rt"
          [(ngModel)]="requireText"
          binary="true"
          label="Require Text?"
        ></p-checkbox>
      </div>

      <div class="">
        <button
          pButton
          type="submit"
          label="Add Hide Reason"
          (click)="addRejectionReason()"
        ></button>
      </div>
    </div>

    <p-table
      #dataTable
      selectionMode="none"
      [value]="rejectionReasons"
      [lazy]="false"
      [rows]="10"
      [responsive]="true"
      [paginator]="true"
      rowHover="true"
      resizableColumns="true"
      [totalRecords]="rejectionReasons.length"
      [rowsPerPageOptions]="[10, 20, 50]"
      [pageLinks]="5"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="reason">Rejection Reason</th>
          <th style="width: 120px">Require text?</th>
          <th>Date Inactive</th>
          <th pSortableColumn="inactiveTimeStamp" style="width: 200px"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr [pSelectableRow]="item">
          <td>{{ item.reason }}</td>
          <td style="text-align: center">
            <p-checkbox
              id="requireText"
              name="requireText"
              [(ngModel)]="item.requireText"
              binary="true"
            ></p-checkbox>
          </td>
          <td>
            <div *ngIf="item.inactiveTimeStamp">
              {{ item.inactiveTimeStamp | date : 'dd/MM/yyy HH:mm' }}
            </div>
            <div *ngIf="!item.inactiveTimeStamp"></div>
          </td>
          <td style="text-align: center; width: 200px">
            <button
              *ngIf="!item.inactiveTimeStamp"
              type="button"
              pButton
              (click)="deactivateRejectionReason(item)"
              icon="fa ui-icon-lock"
              pTooltip="Deactivate reason"
            ></button>
            <button
              *ngIf="item.inactiveTimeStamp"
              type="button"
              pButton
              (click)="reactivateRejectionReason(item)"
              icon="fa ui-icon-lock-open"
              pTooltip="Reactivate reason"
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
